import styled from 'styled-components';

export const WantToCallMeStyles = styled.div`
  min-height: calc(100vh - 212px);
  display: flex;
  flex-direction: column;

  .customNumber {
    span {
      color: ${(props) => props.theme.primary.primary50};
      display: block;
    }
    margin-top: 48px;
  }
`;
